class CartUpsells extends HTMLElement {
  constructor() {
      super();

      this.parser = new DOMParser();
      this.cart = this.closest('.drawer__footer') ? document.querySelector('cart-drawer') : document.querySelector('cart-items');
      this.cartItemsWrapper = this.cart?.querySelector('cart-drawer-items') || this.cart || null;
      this.upsellsWrapper = this.querySelector('.cart-upsells__content') || null;
      
      this.upsellsUrl = this.dataset.upsellsUrl;
  }

  connectedCallback() {
     this.renderUpsells();
  }

  async renderUpsells() {
      const productIds = this.getProductsIds();
      const upsellsMarkup = await this.getUpsellsMarkup(productIds);
      
      if (!upsellsMarkup) return;
      
      this.innerHTML = upsellsMarkup.innerHTML;
      this.enableSlider();
      this.classList.remove('is-empty')
  }

  async enableSlider() {
      const sliderElement = this.querySelector('.cart-upsells__body.swiper') || null;
      if (!sliderElement) return;

      await window.loadSwiperAssets();
      new Swiper(sliderElement, {
          slidesPerView: 1.6,
          slidesPerGroup: 1,
          spaceBetween: 10,
          a11y: {
              enabled: true,
              slideRole: 'listitem'
          },
          pagination: {
              el: ".cart-upsells__pagination.swiper-pagination",
              type: 'bullets',
              clickable: true
          },
          breakpoints: {
            768: {
              slidesPerView: 2.4
            }
          }
      })
  }

  getProductsIds() {
      if (!this.cartItemsWrapper) return;

      return Array.from(this.cartItemsWrapper.querySelectorAll('tr.cart-item'))
      .map(cartItem => cartItem.dataset.isUpsellProduct === 'true' ? '' : cartItem?.dataset.productId)
      .filter(Boolean);
  }

  async getUpsellsMarkup(productIds) {
      if (!productIds.length) return;

      let promisesArray = productIds.map(id => {
          const url = this.upsellsUrl.replace('[product_id]', id);
          return fetch(url);
      });

      try {
          const responsesArray = await Promise.all(promisesArray);
          const upsellsMarkupArray = await Promise.all(responsesArray.map(response => this.parseUpsellsMarkup(response)));
          const upsellsArray = this.removeUpsellDuplicates(upsellsMarkupArray.flat());
          const upsellsWrapper = this.upsellsWrapper;
          
          if (!upsellsArray.length) return null;

          const upsellItemsWrapper = upsellsWrapper.querySelector('.cart-upsells__content');

          upsellItemsWrapper.innerHTML = '';
          upsellsArray.forEach(upsell => {
              upsellItemsWrapper.append(upsell.html)
          })
          return upsellsWrapper;
      } catch (error) {
          console.error('Error fetching upsells:', error);
      }
  }

  async parseUpsellsMarkup(response) {
      if (!response.ok) {
          console.error('Failed to fetch upsells markup');
          return;
      }

      const markup = this.parser.parseFromString(await response.text(), 'text/html');
      this.upsellsWrapper = markup.querySelector('cart-upsells');
      const upsells = markup.querySelectorAll('.cart-upsells__content upsell-item');
      const cartItemIds = Array.from(markup.querySelectorAll('.cart-item')).map(element => element.dataset.productId);

      if (!upsells.length) return;
      return Array.from(upsells).map(upsell => {
          const upsellId = upsell.dataset.id;
          const upsellProductId = upsell.dataset.productId;
          if (!upsell || cartItemIds.includes(upsellProductId)) return;
          
          return {
              id: upsellId,
              html: upsell
          }
      });
  }

  removeUpsellDuplicates(upsellsArray) {
      const uniqueMap = new Map();
      upsellsArray.forEach(upsell => {
          if (!upsell) return;

          uniqueMap.set(upsell.id, upsell);
      });

      return Array.from(uniqueMap.values());
  }
}

customElements.define('cart-upsells', CartUpsells)


class UpsellItem extends HTMLElement {
  constructor() {
      super();

      this.id = this.dataset.id;
      this.quantity = this.dataset.quantity;
      this.sellingPlan = this.dataset.sellingPlan || '';
      this.hasCustomPrice = this.dataset.hasCustomPrice === 'true' || false;
      this.flavor = this.querySelector('.flavor__input:checked')?.dataset.flavor || null;


      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

      this.flavorInputs = this.querySelectorAll('.flavor__input');
      this.variantInputs = this.querySelectorAll('.variant__input');
      this.sellingPlanInputs = this.querySelectorAll('.selling-plan__input');
      this.quantityInput = this.querySelector('.upsell__quantity-selector > input') || null;
      this.quantityButtons = this.querySelectorAll('.quantity-selector__button');

      this.optionsTrigger = this.querySelector('.upsell__button.options__button') || null;
      this.submitButton = this.querySelector('.upsell__button.add-to-cart__button') || null;
      this.cachedResults = {};
      
      this.attachEventListeners();
      if (typeof StampedFn != 'undefined') StampedFn?.reloadUGC();
  }

  attachEventListeners() {
      this.submitButton?.addEventListener('click', this.onSubmitHandler.bind(this));
      this.optionsTrigger?.addEventListener('click', this.showOptions.bind(this));

      this.flavorInputs.forEach(input => input.addEventListener('click', this.changeFlavor.bind(this)))
      this.variantInputs.forEach(input => {
          input.addEventListener('change', this.changeId.bind(this));
          input.addEventListener('click', this.onVariantClick.bind(this));
          input.addEventListener('keydown', this.onVariantKeydown.bind(this));
      });
      this.sellingPlanInputs.forEach(input => input.addEventListener('click', this.changeSellingPlan.bind(this)));
      this.quantityButtons.forEach(button => button.addEventListener('click', this.onQuantityChange.bind(this)));
      this.quantityInput?.addEventListener('change', this.onQuantityChange.bind(this));
  }

  async changeFlavor(event) {
      const handle = event.target.value;
      const { flavor } = event.target?.dataset
      if (!handle || !flavor) return;
      
      const product = this.cachedResults[handle] ? this.cachedResults[handle] : await this.getProductByHandle(handle)
      if(!this.cachedResults[handle]) this.cachedResults[handle] = product;

      this.setProductDataByFlavor(product, flavor)
  }

  changeId(event) {
      const id = event.currentTarget.value;
      if (id) this.id = id;
  }

  onVariantClick(event) {
      if (event.detail === 0) return;

      this.changeId(event);
      this.onSubmitHandler();
  }

  onVariantKeydown(event) {
      if (event.key !== 'Enter' || event.repeat) return;

      this.changeId(event);
      this.onSubmitHandler(event);
  }

  changeSellingPlan(event) {
      const sellingPlan = event.target.value;
      if (sellingPlan) this.sellingPlan = sellingPlan;
  }

  changeQuantity(quantity) {
      const minQuantity = parseInt(this.quantityInput.getAttribute('min'));
      const newQuantity = quantity >= minQuantity ? quantity : minQuantity;
      
      this.quantityInput.value = newQuantity;
      this.quantityButtons[0]?.toggleAttribute('disabled', newQuantity == minQuantity);
      this.quantity = newQuantity;
      this._changePrice(newQuantity);
  }

  _changePrice(quantity) {
      const priceWrapper = this.querySelector('[data-price]') || null;
      const compareAtPriceWrapper = this.querySelector('[data-compare-at-price]');
      if (!priceWrapper) return;

      const { price } = priceWrapper.dataset;
      priceWrapper.innerHTML = `$${(price * quantity / 100).toFixed(2)}`;

      if (compareAtPriceWrapper) {
          const { compareAtPrice } = compareAtPriceWrapper.dataset;
          compareAtPriceWrapper.innerHTML = `<del>$${(compareAtPrice * quantity / 100).toFixed(2)}</del>`;
      }
  }

  onQuantityChange(event) {
      if (!this.quantityInput) return;

      const isButton = event.target.tagName == 'BUTTON';
      let quantity = parseInt(this.quantityInput.value);
      
      if (isButton) {
          const { selectorType } = event.target.dataset;
          quantity = selectorType == 'plus' ? quantity + 1 : quantity - 1;
      } else {
          quantity = parseInt(event.target.value);
      }
      
      this.changeQuantity(quantity)
  }

  async getProductByHandle(handle) {
      const data = await fetch(`/products/${handle}.js`);
      const product = await data.json();

      return product;
  }

  setProductDataByFlavor(product, flavor) {
      if (!product) return;

      const { featured_image, variants, selling_plan_groups } = product;
      const { id } = variants[0];
      const { selling_plans: sellingPlans } = selling_plan_groups[0];

      const upsellTitle = this.querySelector('.upsell__title');
      const upsellImage = this.querySelector('.upsell__image > img');

      this._updateUpsellInfo(upsellTitle, upsellImage, featured_image, flavor);
      this._updateSellingPlans(sellingPlans);

      this.flavor = flavor;
      this.id = id;
  }

  _updateUpsellInfo(upsellTitle, upsellImage, featured_image, flavor) {
      upsellTitle.innerHTML = upsellTitle.innerHTML.replace(this.flavor, flavor);
      upsellImage.setAttribute('src', featured_image);
      upsellImage.setAttribute('srcset', `${featured_image}&width=200 200w`);
  }

  _updateSellingPlans(sellingPlans) {
      this.sellingPlanInputs.forEach(input => {
          const { planTitle } = input.dataset;
          if (!planTitle) return;
  
          const matchedPlan = sellingPlans.find(plan => plan.name.includes(planTitle));
          if (matchedPlan) {
              input.value = matchedPlan.id;
              if (input.checked) this.sellingPlan = matchedPlan.id;
          }
      });
  }

  showOptions() {
    this.classList.add('options--shown');
    this.closest('.cart-upsells__body.swiper')?.swiper?.updateAutoHeight();

    requestAnimationFrame(() => {
      this.querySelector('.variant__input:not(:disabled)')?.focus();
    });
  }

  onSubmitHandler(event = false) {
      if (event) event.preventDefault();
      document.dispatchEvent(new Event('theme:loading:start'));

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData();
      formData.append('id', this.id);
      formData.append('quantity', this.quantity);
      if (this.hasCustomPrice) formData.append('properties[_upsell_product]', this.id)
      if (this.sellingPlan) formData.append('selling_plan', this.sellingPlan)

      if (this.cart) {
          formData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
          if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  errors: response.errors || response.description,
                  message: response.message,
              });
              this.error = true;
              return;
          } else if (!this.cart) {
              //this.trackEvents();
              window.location = window.routes.cart_url;
              return;
          }

          if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'product-form',
                  productVariantId: formData['id'],
                  cartData: response,
              });
          this.error = false;
          this.cart.renderContents(response)
      })
      .catch((e) => {
          console.error(e);
      })
      .finally(() => {
          this.submitButton.classList.remove('loading');
          document.dispatchEvent(new Event('theme:loading:end'))
      });
  }
}

customElements.define('upsell-item', UpsellItem)
